import router from '@/router'
import i18n from '@/i18n'

const state = {
  locale: 'ko',
}

const mutations = {
  UPDATE_LOCALE (pState, payload) {
    i18n.locale = payload
    pState.locale = payload
  }
}

const getters = {
  GET_LOCALE: state => state.locale
}

const actions = {
  localStorageChange ({ commit }, locale) {
    commit('UPDATE_LOCALE', locale)
  },
  localeChange ({ commit }, data) {
    router.push({
      query: {
        ...data.query
      },
      params: {
        locale: data.lang === 'ko' ? '' : data.lang
      }
    })
    commit('UPDATE_LOCALE', data.lang)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
